import _taggedTemplateLiteral from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _templateObject, _templateObject2;
var _excluded = ["children"];
import styled from "styled-components";
import React from "react";
import { useTabState, Tab as BaseTab, TabList as BaseTabList, TabPanel as BaseTabPanel } from "reakit/Tab";
import { triangle } from "polished";
import { colors, typography } from "../shared/styles";
var TabsContext = React.createContext();
export function NewTabs(_ref) {
  var children = _ref.children,
    initialState = _objectWithoutProperties(_ref, _excluded);
  var tab = useTabState(initialState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var value = React.useMemo(function () {
    return tab;
  }, Object.values(tab));
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: value
  }, children);
}
var StyledTab = styled(BaseTab)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttext-decoration: none;\n\toutline: none;\n\tcursor: pointer;\n\tposition: relative;\n\tfont-family: ", ";\n\tfont-size: 14px;\n\tfont-weight: 300;\n\tletter-spacing: 0.28px;\n\tflex-grow: 1;\n\tbackground: ", ";\n\tborder: none;\n\tcolor: ", ";\n\tborder-bottom: 1px solid ", ";\n\t&:hover {\n\t\topacity: 0.7;\n\t}\n\t&:not(:last-of-type) {\n\t\tborder-right: 1px solid ", ";\n\t}\n\t&[aria-selected=\"true\"] {\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t\tborder-bottom: 1px solid ", ";\n\t\t&:after {\n\t\t\t", "\n\t\t\ttransform: translateX(-50%);\n\t\t\tposition: absolute;\n\t\t\tz-index: 1;\n\t\t\tcontent: \"\";\n\t\t\ttop: 100%;\n\t\t\tleft: 50%;\n\t\t}\n\t}\n"])), typography.type.primary, colors.plain, colors.secondaryBlue, colors.grayRegular, colors.grayRegular, colors.plain, colors.secondaryBlue, colors.secondaryBlue, triangle({
  pointingDirection: "bottom",
  width: "24px",
  height: "12px",
  foregroundColor: colors.secondaryBlue
}));
export function NewTab(props) {
  var tab = React.useContext(TabsContext);
  return /*#__PURE__*/React.createElement(StyledTab, Object.assign({}, tab, props));
}
var StyledTabList = styled(BaseTabList)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tborder: 1px solid ", ";\n\tborder-bottom: none;\n\tdisplay: flex;\n"])), colors.grayRegular);
export function NewTabList(props) {
  var tab = React.useContext(TabsContext);
  return /*#__PURE__*/React.createElement(StyledTabList, Object.assign({}, tab, props, {
    "aria-label": "Tab List"
  }));
}
export function NewTabPanel(props) {
  var tab = React.useContext(TabsContext);
  return /*#__PURE__*/React.createElement(BaseTabPanel, Object.assign({}, tab, props));
}